export const localStorageConstants = {
  countryStates: 'country-states',
  collaborationLevels: 'collaboration-level',
  collaborationTypes: 'therapy-type',
  collaborationLeads: 'collaboration-Leads',
  category: 'category',
  sexuality: 'sexuality',
  gender: 'gender',
  raceEthnicity: 'race-ethnicity',
  identificationTypes: 'identification-type',
  languages: 'language',
  collaborationTagType: 'collaboration-tag-type',
  roles: 'roles',
  supportType: 'support-type',
  notificationLevel: 'notification-level',
  helperTitle: 'helper-title',
  brandingDetails:'branding',
  notificationType: 'notification-type',
  identifiedGender: 'identified-gender',
  goToPreviousRoute: 'go-to-previous-route',
  userDetails: 'userdetails',
  userSwitchSignal: 'user-switch-signal',
  errorMessage: 'An error occurred.',
  loginError: 'An error occurred. Please try again.',
  changePassword: 'Password has been changed successfully.',
  errorResetPassword: 'There was an error processing the password reset.',
  errorOldPassword: 'Old password is incorrect.',
  successMessage: 'Successfully Updated.',
  deleteAssessment: 'Are you sure you want to delete this questionnaire instance?',
  confirmationMessage: 'Are you sure you want to delete this note?',
  wrongCredentials: 'Invalid credentials.',
  invalidEmail: 'Invalid email or tenant.',
  duplicateAbbreviation: 'Agency abbreviation already exists.Try with new one.',
  duplicateAgencyName: 'Agency name already exists.Try with new one.',
  addSuccessMessage: 'Successfully added.',
  deleteSuccess: 'Successfully deleted.',
  duplicateEmail: 'Email already exists.',
  saveError: 'Error occured while saving data. Please try again.',
  requiredFields: 'Please fill all required fields.',
  confirmCollaboration: 'Are you sure you want to delete this collaboration?',
  confirmPerson: 'Are you sure you want to delete this person?',
  confirmSupport: 'Are you sure you want to delete this support?',
  confirmHelper: 'Are you sure you want to delete this helper?',
  confirmActivateHelper: 'Are you sure you want to activate this helper',
  confirmActivatePerson: 'Are you sure you want to activate this person',
  confirmActivation: 'Confirm Activation',
  confirmActive: 'Activate',
  confirmDelete: 'Are you sure you want to delete',
  assessmentSubmitted: 'Thank you. Your responses have been sent.',
  errorEmailAssessment: 'Email assessment no longer required.',
  confirmChanges: 'Do you want to submit responses?',
  expand: 'Expand All',
  collapse: 'Collapse All',
  noData: 'No data found.',
  noAssessment: 'No Assessments Submitted.',
  noMatchError: 'No Submitted Assessment Match the Filters.',
  confirmPriority: 'Do you want to save your priority changes before proceeding?',
  successPriority: 'Priority saved successfully.',
  saveFailed: 'Saving failed!',
  notImplemented: 'Not Implemented.',
  updateError: 'Updation failed.',
  questionnaireDeleteConfirmation: 'Are you sure you want to delete this questionnaire?',
  questionnaireCannotDelete: 'Cannot delete. The questionnaire already has an assessment.',
  descriptionLength: '2500',
  descriptionRestrictedLength: '1000',
  descriptionMaxLength: '200',
  importMessage: 'File successfully uploaded for import. You will be notified through email once the import process is completed.',
  downloadSuccessMessage: 'Successfully Downloaded',
  requiredConfidentialityLanguage: 'Signed Release Required',
  personRequestedConfidentialityLanguage: 'Consumer Requested Confidential',
  otherConfidentialityLanguage: 'Consumer Reaction Sensitive',
  postalCode: 'A* ASS',
  alternatePostalCode: '00000',
  maxLengthUS: 5,
  maxLengthNonUS: 15,
  setHelper: 'Helper ',
  setEmailHelper: ' has been created and an email has been sent to ',
  setInviteHelper: ' inviting them to complete setting up their account.',
  noSignUpMail: ' has been created successfully.',
  communimetricVoiceTypeId: 1,
  supportVoiceTypeId: 3,
  consumerVoiceTypeId: 2,
  helperVoiceTypeId: 4,
  namePattern:/^[a-zA-Z]+[a-zA-Z\\s.']*?[^0-9]$/,
  defaultBranding: 'default-branding',
  defaultConfigurationId: 'defaultConfigurationID',
  configurationId: 'configurationID',
  careCircle:'care-circle',
  instrumentAgency:'instrument-agency',
  countries:'countries-list',
  responseValueTypes: 'responseValueTypes',
  inviteToCompletSubmitFlag: 'Submit',
  confirmSkipResponseMessage:'Changing this answer will clear responses you’ve already entered for other questions that no longer apply. Do you want to continue?',
  fileSizeValidationMessage: "File size should not exceed",
  confirmChildValueDiscardMessage:'Changing your response will delete all previously entered information related to this question.',
  confirmDiscardChanges: 'Do you want to discard your changes before proceeding?',
  helperEndDateWarningMessage: 'This user may have active management or review responsibilities. Do you want to proceed?',
  helperEndDateWarningBtnLabel: 'Proceed Anyway',
  helperEndDateWarningCancelLabel: 'Review Assignments',
};

export const localStorageVariables = {
  token: 'token',
  role: 'role',
  email: 'email',
  agencyId: 'agencyId',
  Tenant: 'Tenant',
  agencyName: 'agencyName',
  UserId: 'UserId',
  tenantAbbreviation: 'tenantAbbreviation',
  setDefaultAgency: 'setDefaultAgency',
  username: 'username',
  refreshToken: 'refreshToken',
  name: 'name',
  phone: 'phone',
  userType: 'userType',
  defaultAgency: 'defaultAgency',
  authenticationSource: 'authenticationSource',
  isFromAdvancedSearch:'isFromAdvancedSearch'
};

export const inputElementConstants = {
  nameMaxLength: 30,
  agencyNameMaxLength: 100,
  abbrevationMaxLength: 15,
  codeCollaboration: 50,
  abbreviationCollaboration: 15
};
export const oktaConfigurations = {
    local:'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO&client_id=9994db7f-2dc7-4bac-bf8a-93bf04067890&nonce=defaultNonce&redirect_uri=https%3A%2F%2Flocalhost%3A4200%2F&scope=openid&response_type=id_token',
    dev: 'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO&client_id=9994db7f-2dc7-4bac-bf8a-93bf04067890&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fagency1.pcis-dev.com&scope=openid&response_type=id_token',
    qa: 'https://opeekab2cqa.b2clogin.com/opeekab2cqa.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO&client_id=1108c96c-8377-4cd6-ae89-9b303f5eab37&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fagency1.pcis-qa.com%2F&scope=openid&response_type=id_token',
    stage: 'https://opeekab2cqa.b2clogin.com/opeekab2cqa.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO&client_id=1108c96c-8377-4cd6-ae89-9b303f5eab37&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fstage-login.p-cis.com&scope=openid&response_type=id_token',
    demo:'https://pcisdemoadb2c.b2clogin.com/pcisdemoadb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO&client_id=88b3312b-8c7f-4278-908b-7c18fdd48b34&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fdemo-login.p-cis.com&scope=openid&response_type=id_token',
    prod: 'https://pcisadb2c.b2clogin.com/pcisadb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO&client_id=d3a1123b-2b73-4820-9c60-d42ed97a6280&nonce=defaultNonce&redirect_uri=https%3A%2F%2Flogin.p-cis.com&scope=openid&response_type=id_token',
    prod1: 'https://pcisadb2c.b2clogin.com/pcisadb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO&client_id=d3a1123b-2b73-4820-9c60-d42ed97a6280&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fapp1.p-cis.com%2F&scope=openid&response_type=id_token',
    training: 'https://pcisb2ctraining.b2clogin.com/pcisb2ctraining.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO&client_id=50cb0011-2775-4c43-a640-798902777955&nonce=defaultNonce&redirect_uri=https%3A%2F%2Ftraining-login.p-cis.com&scope=openid&response_type=id_token'
};

export const clients = {
  safy: 'safy',
  opeeka: 'opeeka',
  cdss: 'cdss'
};

export const optionsDropdownValues = [
  {
    value: 'notification-level',
    displayName: 'Notification Level',
    index: 1
  },
  {
    value: 'therapy-type',
    displayName: 'Collaboration Category',
    index: 2
  }, {
    value: 'collaboration-level',
    displayName: 'Collaboration Level',
    index: 3
  },
  {
    value: 'collaboration-tag-type',
    displayName: 'Collaboration Type',
    index: 4
  }, {
    value: 'identified-gender',
    displayName: 'Identified Gender',
    index: 5
  }, {
    value: 'identification-type',
    displayName: 'Identifier Type',
    index: 6
  }, {
    value: 'language',
    displayName: 'Language',
    index: 7
  }, {
    value: 'helper-title',
    displayName: 'Position Title',
    index: 8
  }, {
    value: 'race-ethnicity',
    displayName: 'Race/Ethnicity',
    index: 9
  }, {
    value: 'gender',
    displayName: 'Sex',
    index: 10
  }, {
    value: 'sexuality',
    displayName: 'Sexual Orientation',
    index: 11
  }, {
    value: 'support-type',
    displayName: 'Support Type',
    index: 12
  }
];

export const selectionsDropdownValues = [
  {
    value: 'care-circle',
    displayName: 'Care Circle',
    index: 1
  },
  {
    value: 'instrument-agency',
    displayName: 'Instrument Agency',
    index: 2
  }
];

export const templateList = [
  {
    value: 'helper',
    displayName: 'Helper',
    index: 1,
    url: '',
    questionnaireList: []
  }, {
    value: 'people',
    displayName: 'People',
    index: 2,
    url: '',
    questionnaireList: []
  }, {
    value: 'assessment',
    displayName: 'Assessment',
    index: 3,
    url: '',
    questionnaireList: [
      {
        questionnaireId: 110,
        questionnaireName: 'CANS-0',
        questionnaireURL: ''
      }, {
        questionnaireId: 111,
        questionnaireName: 'CANS-1',
        questionnaireURL: ''
      }, {
        questionnaireId: 112,
        questionnaireName: 'CANS-2',
        questionnaireURL: ''
      }, {
        questionnaireId: 113,
        questionnaireName: 'CANS-3',
        questionnaireURL: ''
      },
    ]
  }
];

export const hourList =
  [
    {
      displayName: '01',
      id: '01'
    },
    {
      displayName: '02',
      id: '02'
    },
    {
      displayName: '03',
      id: '03'
    },
    {
      displayName: '04',
      id: '04'
    },
    {
      displayName: '05',
      id: '05'
    },
    {
      displayName: '06',
      id: '06'
    },
    {
      displayName: '07',
      id: '07'
    },
    {
      displayName: '08',
      id: '08'
    },
    {
      displayName: '09',
      id: '09'
    },
    {
      displayName: '10',
      id: '10'
    },
    {
      displayName: '11',
      id: '11'
    },
    {
      displayName: '12',
      id: '12'
    },
  ];

export const minuteList = [
  {
    "displayName": '00',
    "value": '00'
  },
  {
    "displayName": '01',
    "value": '01'
  },
  {
    "displayName": '02',
    "value": '02'
  },
  {
    "displayName": '03',
    "value": '03'
  },
  {
    "displayName": '04',
    "value": '04'
  },
  {
    "displayName": '05',
    "value": '05'
  },
  {
    "displayName": '06',
    "value": '06'
  },
  {
    "displayName": '07',
    "value": '07'
  },
  {
    "displayName": '08',
    "value": '08'
  },
  {
    "displayName": '09',
    "value": '09'
  },
  {
    "displayName": '10',
    "value": '10'
  },
  {
    "displayName": '11',
    "value": '11'
  },
  {
    "displayName": '12',
    "value": '12'
  },
  {
    "displayName": '13',
    "value": '13'
  },
  {
    "displayName": '14',
    "value": '14'
  },
  {
    "displayName": '15',
    "value": '15'
  },
  {
    "displayName": '16',
    "value": '16'
  },
  {
    "displayName": '17',
    "value": '17'
  },
  {
    "displayName": '18',
    "value": '18'
  },
  {
    "displayName": '19',
    "value": '19'
  },
  {
    "displayName": '20',
    "value": '20'
  },
  {
    "displayName": '21',
    "value": '21'
  },
  {
    "displayName": '22',
    "value": '22'
  },
  {
    "displayName": '23',
    "value": '23'
  },
  {
    "displayName": '24',
    "value": '24'
  },
  {
    "displayName": '25',
    "value": '25'
  },
  {
    "displayName": '26',
    "value": '26'
  },
  {
    "displayName": '27',
    "value": '27'
  },
  {
    "displayName": '28',
    "value": '28'
  },
  {
    "displayName": '29',
    "value": '29'
  },
  {
    "displayName": '30',
    "value": '30'
  },
  {
    "displayName": '31',
    "value": '31'
  },
  {
    "displayName": '32',
    "value": '32'
  },
  {
    "displayName": '33',
    "value": '33'
  },
  {
    "displayName": '34',
    "value": '34'
  },
  {
    "displayName": '35',
    "value": '35'
  },
  {
    "displayName": '36',
    "value": '36'
  },
  {
    "displayName": '37',
    "value": '37'
  },
  {
    "displayName": '38',
    "value": '38'
  },
  {
    "displayName": '39',
    "value": '39'
  },
  {
    "displayName": '40',
    "value": '40'
  },
  {
    "displayName": '41',
    "value": '41'
  },
  {
    "displayName": '42',
    "value": '42'
  },
  {
    "displayName": '43',
    "value": '43'
  },
  {
    "displayName": '44',
    "value": '44'
  },
  {
    "displayName": '45',
    "value": '45'
  },
  {
    "displayName": '46',
    "value": '46'
  },
  {
    "displayName": '47',
    "value": '47'
  },
  {
    "displayName": '48',
    "value": '48'
  },
  {
    "displayName": '49',
    "value": '49'
  },
  {
    "displayName": '50',
    "value": '50'
  },
  {
    "displayName": '51',
    "value": '51'
  },
  {
    "displayName": '52',
    "value": '52'
  },
  {
    "displayName": '53',
    "value": '53'
  },
  {
    "displayName": '54',
    "value": '54'
  },
  {
    "displayName": '55',
    "value": '55'
  },
  {
    "displayName": '56',
    "value": '56'
  },
  {
    "displayName": '57',
    "value": '57'
  },
  {
    "displayName": '58',
    "value": '58'
  },
  {
    "displayName": '59',
    "value": '59'
  }
];
export const aMorPm = [
  {
    displayName: 'AM',
    id: 'AM'
  },
  {
    displayName: 'PM',
    id: 'PM'
  },
];

export const titleFont = [
  {
    id: 1,
    DisplayName: "Montserrat Bold",
    value:"Montserrat-bold"
  },
  {
    id: 4,
    DisplayName: "Aller Bold",
    value:"Aller_Bd"
  }
];

export const bodyFont = [
  {
    id: 1,
    DisplayName: "Montserrat Semi Bold",
    value:"Montserrat-semi-bold"
  },
  {
    id: 2,
    DisplayName: "Aller Semi Bold",
    value:"Aller_Lt"
  }
];

export const subBodyFont = [
  {
    id: 1,
    DisplayName: "Montserrat Regular",
    value:"Montserrat-Regular"
  },
  {
    id: 2,
    DisplayName: "Aller Regular",
    value:"Aller_Rg"
  },
];

export const attributesToChange = [
  {
    id: 1,
    key: "Headers",
    attributeList:["Headers","SideBarActive","CardBorderColor","ChartDarkBorder","NeedsReportInProgressCard"]
  },
  {
    id: 2,
    key: "Button",
    attributeList:["Button","Button2","LinkButtons","BtnBlue"]
  },
  {
    id: 3,
    key: "Notification1",
    attributeList:["Notification1","NeedsReportGoalReachedCard","AssessmentSave"]
  },
  {
    id: 4,
    key: "ChartLight",
    attributeList:["ChartLight"]
  },
  {
    id: 5,
    key: "ButtonActive",
    attributeList:["ButtonActive","EditBtn"]
  },
  {
    id: 6,
    key: "PrimaryAlertColor",
    attributeList:["PrimaryAlertColor"]
  },
  {
    id: 7,
    key: "SuccessAlertColor",
    attributeList:["SuccessAlertColor"]
  }
];
export const assesmentFileTypes = ".doc,.docx,.xls,.xlsx,.pdf,.jpg,.png,.bmp,.txt,.csv";

export const templateReplaceKey = "{{personName}}"
export const versioning = { // versioning key name must be equal to env name
  'magellan-prod': '1.104.0',
  'magellan-uat': '1.104.0',
  'magellan-training' : '1.104.0',
  'magellan-qa': '1.104.0',
  'magellan-dev': '1.104.0',
  prod: '1.104.0',
  prod1: '1.104.0',
  training: '1.104.0',
  staging: '1.104.0',
  qa: '1.104.0',
  dev: '1.104.0',
  'cdss-dev': '1.104.0',
  'cdss-qa': '1.104.0',
  'cdss-sit': '1.104.0',
  'cdss-int': '1.104.0',
  'cdss-perf': '1.104.0'
};

export const recurrenceMonth = [
  {
    monthId: 1,
    maxDayCount: 31,
    minDayCount: 1
  },
  {
    monthId: 2,
    maxDayCount: 29,
    minDayCount: 1
  },
  {
    monthId: 3,
    maxDayCount: 31,
    minDayCount: 1
  },
  {
    monthId: 4,
    maxDayCount: 30,
    minDayCount: 1
  },
  {
    monthId: 5,
    maxDayCount: 31,
    minDayCount: 1
  },
  {
    monthId: 6,
    maxDayCount: 30,
    minDayCount: 1
  },
  {
    monthId: 7,
    maxDayCount: 31,
    minDayCount: 1
  },
  {
    monthId: 8,
    maxDayCount: 31,
    minDayCount: 1
  },
  {
    monthId: 9,
    maxDayCount: 30,
    minDayCount: 1
  },
  {
    monthId: 10,
    maxDayCount: 31,
    minDayCount: 1
  },
  {
    monthId: 11,
    maxDayCount: 30,
    minDayCount: 1
  },
  {
    monthId: 12,
    maxDayCount: 31,
    minDayCount: 1
  }
];
export const optionTypes = [
  {
    "value": "therapy-type",
    "displayName": "Collaboration Category",
    "descriptionLength": 1000
  },
  {
    "value": "collaboration-level",
    "displayName": "Collaboration Level",
    "descriptionLength": 255
  },
  {
    "value": "collaboration-tag-type",
    "displayName": "Collaboration Type",
    "descriptionLength": 255
  },
  {
    "value": "identified-gender",
    "displayName": "Identified Gender",
    "descriptionLength": 100
  },
  {
    "value": "identification-type",
    "displayName": "Identifier Type",
    "descriptionLength": 100
  },
  {
    "value": "language",
    "displayName": "Language",
    "descriptionLength": 100
  },
  {
    "value": "notification-level",
    "displayName": "Notification Level",
    "descriptionLength": 255
  },
  {
    "value": "helper-title",
    "displayName": "Position Title",
    "descriptionLength": 255
  },
  {
    "value": "race-ethnicity",
    "displayName": "Race/Ethnicity",
    "descriptionLength": 1000
  },
  {
    "value": "gender",
    "displayName": "Sex",
    "descriptionLength": 100
  },
  {
    "value": "sexuality",
    "displayName": "Sexual Orientation",
    "descriptionLength": 100
  },
  {
    "value": "support-type",
    "displayName": "Support Type",
    "descriptionLength": 100
  }
]
